import { Plus } from '@phosphor-icons/react'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import { FAQS } from '../data/travel'

export default function FAQ() {
  const [open, setOpen] = useState(0)

  return (
    <section id="preguntas" className="scroll-mt-16 bg-white px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy-950 md:text-5xl">Preguntas frecuentes</h2>
          <p className="mt-4 max-w-[46ch] text-base leading-relaxed text-navy-700/60">
            Si la tuya no está aquí, escríbenos. Respondemos en horario de oficina y en menos de 24 horas.
          </p>
        </div>
        <ul className="lg:col-span-7">
          {FAQS.map((item, i) => {
            const isOpen = open === i
            return (
              <li key={item.q} className="border-t border-navy-900/10 last:border-b">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-6 py-5 text-left"
                >
                  <span className="font-display text-lg font-bold text-navy-950">{item.q}</span>
                  <Plus
                    size={20}
                    weight="bold"
                    className={`shrink-0 text-sunset-500 transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="max-w-[62ch] pb-6 text-base leading-relaxed text-navy-700/60">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
